import { del, get, post, put } from '../axios/axiosGateway';

export const getCRUDList = ({ entity, params }) => {
  return get(`/crud/${entity}`, params);
};

export const getCRUDItem = ({ entity, params, id }) => {
  return get(`/crud/${entity}/${id}`, params);
};

export const postCRUD = ({ entity, data }) => {
  return post(`/crud/${entity}`, data);
};

export const putCRUD = ({ entity, data, params, id }) => {
  return put(`/crud/${entity}/${id}`, data, params);
};

export const delCRUD = ({ entity, params, id }) => {
  return del(`/crud/${entity}/${id}`, params);
};

export const placeholderCRUD = ({ page, pageSize }) => ({
  data: [],
  pagination: {
    totalRecords: 0,
    page,
    pageSize,
    pagesCount: 1,
  },
});
